module.exports = __webpack_public_path__ + "img/main_mgcafee1.df2d3691.jpg";